import FPDManager from './fpd-manager.js'
import { includes, each, isNil } from 'lodash'

export default class ViewSelectionOperator {
  constructor(productPage) {
    this.productPage = productPage
  }

  get taProduct() {
    return this.productPage.taProduct
  }

  initViewSelection() {
    if(this.hasOutsideViewSelection() && !this.productPage.fpdProductJSON?.plugin_options?.viewThumbnailsWrapper) {
      this.productPage.updateFancyPluginOptions('viewThumbnailsWrapper', ".fpd-views-outside-below-wrapper")
      const viewSelectionWrapper = document.createElement('div')
      viewSelectionWrapper.classList.add('fpd-views-outside-below-wrapper', 'fpd-show-empty')

      const fpdContainer = document.querySelector(this.taProduct.fpdContainer)
      if(fpdContainer) {
        fpdContainer.insertAdjacentElement("afterend", viewSelectionWrapper)
      }
    }
  }

  hasOutsideViewSelection() {
    return includes(this.productPage.fpdProductJSON.container_classes, 'fpd-views-outside-below')
  }
}